import { gatewayMessages } from 'src/features/gateway/utils/messages';
import { REQUIRED_IDENTIFIER_TYPES } from 'src/features/gateway/utils/types';

export const requiredIdentifiersTranslationMap: Record<
    REQUIRED_IDENTIFIER_TYPES,
    { id: string; defaultMessage: string }
> = {
    [REQUIRED_IDENTIFIER_TYPES.LICENSE_PLATE]: gatewayMessages.licensePlate,
    [REQUIRED_IDENTIFIER_TYPES.TICKET]: gatewayMessages.ticket,
    [REQUIRED_IDENTIFIER_TYPES.ACCESS_KEY]: gatewayMessages.accessKey,
};

export const GATEWAY_IDENTIFIER_TYPE_MAP = {
    [REQUIRED_IDENTIFIER_TYPES.ACCESS_KEY]: gatewayMessages.accessKey,
    [REQUIRED_IDENTIFIER_TYPES.TICKET]: gatewayMessages.ticket,
    [REQUIRED_IDENTIFIER_TYPES.LICENSE_PLATE]: gatewayMessages.licensePlate,
};
